import React, {useState, useEffect, useContext} from 'react';
import styles from './Home.module.css';

import {Route, Routes, useLocation, Navigate} from 'react-router-dom';

import ConnectWalletHeader from "../header/ConnectWalletHeader";
import LeftPanel from "../LeftPanel/LeftPanel";

import {LayoutGroup} from 'framer-motion';
import Dashboard from "../Dashboard/Dashboard";
import Account from "../Account/Account";
import {getConfig} from "../../configs/config";
import {SwapMainAppContext} from "../../context/SwapMainAppContext";
import TeleOpSelection from "../TeleOp/TeleOpSelection";
import TeleOp from "../TeleOp/TeleOp";
import GlobalLive from "../TeleOp/GlobalLive";
import WhitePaper from "../WhitePaper/WhitePaper";
import InviteFriends from "../InviteFriends/InviteFriends";
import ReferralLandingPage from "../InviteFriends/ReferralLandingPage";
import GraspDetectionOverlay from "../RoarmDetector/GraspDetectionOverlay";
import TeleOpLocal from "../TeleOp/TeleOpLocal";
import DataHub from "../Data/DataHub";
import RoboticDataPage2 from "../RoboticData/RoboticDataPage2";
import {ROBOTIC_DATA_UI_ENABLED} from "../RoboticData/access";
// import FleetV2 from '../Fleet/FleetV2';

const Home = () => {
    const location = useLocation();
    const isInvitePage = location.pathname === '/invite';
    const isDataRoute = location.pathname === '/data'
        || location.pathname.startsWith('/data/')
        || location.pathname.startsWith('/robotic-data');

    const [txTrigger, setTxTrigger] = useState(0);

    const [walletAddress, setWalletAddress] = useState(null);

    // Final "confirmed" amount to pass to ConnectWalletHeader
    const [confirmedAmount, setConfirmedAmount] = useState("0");


    const [isWalletLoading, setIsWalletLoading] = useState(true);


    const [UTCTimeTransaction, setUTCTimeTransaction] = useState(null);


    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);
    const {
        setUsdtBalance,
        setUsdcBalance,
        showPanel,
        setShowPanel,
    } = useContext(SwapMainAppContext);
    // ------------------------ Referral Code Store in local ------------------------
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const referralCode = searchParams.get('ref');

        if (referralCode) {
            localStorage.setItem('referralCode', referralCode);
        }
    }, []);

    useEffect(() => {
        const loadAppConfig = async () => {
            try {
                await getConfig();
            } catch (error) {
                console.error('Error initializing application config from Home component:', error);
            }
        };
        loadAppConfig();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const lastWallet = localStorage.getItem("lastConnectedWallet")
        if (!lastWallet) {
            setIsWalletLoading(false)
        }
    }, []);


    return (
        <LayoutGroup>
            <div
                className={`${styles.outerContainer} ${isDataRoute ? styles.outerContainerDataRoute : ''} ${isLeftPanelCollapsed ? styles.leftPanelCollapsed : ''}`}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    height: '150%',
                    width: '100vw'
                }}
            >

                {/* LEFT PANEL */}
                <LeftPanel
                    walletAddress={walletAddress}
                    onPanelStateChange={setIsLeftPanelCollapsed}
                />
                {/* RIGHT PANEL */}
                <div
                    className={`
                        ${styles.rightPanel}
                        ${isDataRoute ? styles.rightPanelDataRoute : ''}
                        ${isLeftPanelCollapsed ? styles.rightPanelExpanded : ''}
                        ${isInvitePage ? styles.rightPanelInvitePage : ''}
                      `}
                    style={{display: 'flex', flexDirection: 'column'}}
                >
                    <ConnectWalletHeader
                        amount={confirmedAmount}
                        transactionTrigger={txTrigger}
                        onWalletConnected={(publicKey, usdtLeft, usdcLeft) => {
                            setWalletAddress(publicKey);
                            setUsdtBalance(usdtLeft);
                            setUsdcBalance(usdcLeft);
                            setIsWalletLoading(false);
                        }}
                        transactionTime={UTCTimeTransaction}
                        showPanel={showPanel}
                        setShowPanel={setShowPanel}
                    />
                    {/* <div className={styles.contentAreaOuter}> */}
                    <div className={`${styles.contentAreaOuter} ${isDataRoute ? styles.contentAreaOuterDataRoute : ''}`}>

                        <div className={`${styles.contentArea} ${isDataRoute ? styles.contentAreaData : ''}`}>
                            <Routes>
                                <Route path="/" element={<Dashboard/>}/>
                                 {/* Robot fleet route - supporting redirection for the new /data/fleet */}
                                <Route path="/fleet" element={<Navigate to="/data/fleet" replace/>} />

                                <Route path="/account" element={<Account/>}/>

                                {/* Robot Control Center selection */}
                                <Route path="/robots-center" element={<TeleOpSelection/>}/>

                                {/* Backward compatibility: redirect old selection path to new */}
                                <Route path="/tele-op" element={<Navigate to="/robots-center" replace/>}/>

                                {/* Tele-Op per-robot route */}
                                <Route path="/tele-op/:robotSlug" element={<TeleOp/>}/>

                                <Route path='/live-control' element={<GlobalLive/>}/>
                                <Route path='/whitepaper' element={<WhitePaper/>}/>
                                <Route path="/invite" element={<InviteFriends/>}/>
                                <Route path="/data/*" element={<DataHub/>}/>
                                {/* Keep the legacy page code, but hide subscriber access in this app. */}
                                <Route
                                    path="/robotic-data"
                                    element={ROBOTIC_DATA_UI_ENABLED ? <RoboticDataPage2/> : <Navigate to="/" replace/>}
                                />
                                <Route
                                    path="/robotic-data/:episodeId"
                                    element={ROBOTIC_DATA_UI_ENABLED ? <RoboticDataPage2/> : <Navigate to="/" replace/>}
                                />
                                <Route path="/roarm-detect" element={<GraspDetectionOverlay/>}/>
                                <Route path="/teleop/arcade" element={<TeleOpLocal/>}/>
                            </Routes>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutGroup>
    );
};

export default Home;
